'use client';

import { Stack, Heading, VStack, Checkbox } from '@chakra-ui/react';
import { Formik, Form } from 'formik';

import { LoadingButton } from '@components/custom-buttons';
import { FormControlTextField, FormControlTextArea } from '@components/custom-form-control';
import { CustomText } from '@components/Custom-text';
import { useAppDispatch } from '@hooks/store';
import { ContactFormSchema } from '@modules/contact/schema';
import { useContactUsMutation } from '@modules/help-support/api';
import { ContactSupportPayload } from '@modules/help-support/types';
import { showToast } from '@slices/apiSlice';

const ContactForm = () => {
    const dispatch = useAppDispatch();
    const [addContactForm, { isLoading }] = useContactUsMutation();
    const initialValues = {
        name: '',
        subject: '',
        email: '',
        phone: '',
        description: '',
    };

    const handleSubmit = async (
        values: ContactSupportPayload,
        { resetForm }: { resetForm: any }
    ) => {
        const response: any = await addContactForm({
            ...values,
            phone: values.phone!,
            subject: values.subject!,
        });
        if (response?.error) {
            dispatch(showToast({ variant: 'error', description: response.error[0] }));
        } else {
            dispatch(
                showToast({
                    variant: 'success',
                    description: 'Message sent successfully',
                })
            );
            resetForm({});
        }
    };
    return (
        <Formik
            initialValues={initialValues}
            validationSchema={ContactFormSchema}
            onSubmit={handleSubmit}
        >
            {() => (
                <Form>
                    <Stack alignItems="center" spacing="4" py={12}>
                        <Heading color="primary.dark" size="xl">
                            Get in touch
                        </Heading>
                        <CustomText size="md" color="shadowSlate" textAlign="center">
                            We’d love to hear from you. Please fill out this form.
                        </CustomText>

                        <VStack align="flex-start" w={{ base: '100%', md: 400 }} gap={4}>
                            <FormControlTextField
                                name="name"
                                placeholder="Enter name"
                                label="Name"
                                type="text"
                                isRequired
                            />
                            <FormControlTextField
                                name="email"
                                placeholder="Enter email"
                                label="Email"
                                type="email"
                                isRequired
                            />
                            <FormControlTextField
                                name="phone"
                                placeholder="Enter phone number"
                                label="Phone"
                                type="tel"
                                isRequired
                            />
                            <FormControlTextField
                                name="subject"
                                placeholder="Enter subject"
                                label="Subject"
                                type="text"
                                isRequired
                            />

                            <FormControlTextArea
                                name="description"
                                label="Message"
                                placeholder="Leave us a message..."
                                isRequired
                            />
                            <Checkbox color="mainText">
                                I accept the Terms of Use and Privacy Policy
                            </Checkbox>
                            <LoadingButton
                                buttonLabel="Send Message"
                                type="submit"
                                isLoading={isLoading}
                                loadingText="Sending Message"
                            />
                        </VStack>
                    </Stack>
                </Form>
            )}
        </Formik>
    );
};

export default ContactForm;
